import { render, staticRenderFns } from "./OperaGoodsInfoWindow.vue?vue&type=template&id=0e7d8096&scoped=true&"
import script from "./OperaGoodsInfoWindow.vue?vue&type=script&lang=js&"
export * from "./OperaGoodsInfoWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaGoodsInfoWindow.vue?vue&type=style&index=0&id=0e7d8096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7d8096",
  null
  
)

export default component.exports